import React, { FunctionComponent, useEffect, useMemo, useState } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { ArtPieceFileTypes } from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import SelectInput from "../../../components/Form/Select/Select"
import Upload from "../../../components/Upload/Upload"
import { iArtPiece } from "../../../definitions/ArtPieces"

interface iProps {
  item?: iArtPiece
}

const ArtPieceUploads: FunctionComponent<iProps> = ({ item }) => {
  const { watch, setValue, getValues } = useFormContext()
  const {
    fileType,
    file,
    shrPreviewImageId,
    generatePreview,
  }: Partial<iArtPiece> = watch([
    "fileType",
    "file",
    "shrPreviewImageId",
    "generatePreview",
  ])

  const [type, setType] = useState(fileType)

  const fileTypeVal = getValues("fileType")

  useEffect(() => {
    if (!type) {
      setType(fileTypeVal)
    }
  }, [fileTypeVal])

  useEffect(() => {
    if (fileType) {
      setType(fileType)
    }
  }, [fileType])

  const fileCollection = useMemo(() => {
    switch (fileType) {
      case "IMAGE":
        return "Files_Images"
      case "VIDEO":
        return "Files_Videos"
      case "AUDIO":
        // setValue("generatePreview", false)
        return "Files_Audio"
      case "MESH":
        // setValue("generatePreview", false)
        return "Files_Meshes"
      default:
        return ""
    }
  }, [fileType])

  useEffect(() => {
    if (fileCollection === "Files_Audio" || fileCollection === "Files_Meshes") {
      setValue("generatePreview", false)
    }
  }, [fileCollection])

  return (
    <div className="scrollable">
      <Controller
        name="fileType"
        render={({ onChange, value }) => (
          <SelectInput
            onChange={onChange}
            value={value}
            name="fileType"
            options={ArtPieceFileTypes}
          />
        )}
      />
      {type && (
        <>
          <Upload
            name="file"
            fileCollection={fileCollection}
            maxFiles={1}
            initialFiles={[item?.file || ""]}
            label="Upload File"
          />
          {/* {file && fileType === "VIDEO" && (
            <VideoWrap fileCollection={fileCollection} file={file} />
          )} */}
          {file && type === "AUDIO" && <div> Audio File</div>}
          {type !== "MESH" && type !== "AUDIO" && (
            <FormInput
              label="Generate preview automatically"
              name={"generatePreview"}
              type="checkbox"
            />
          )}
          {(shrPreviewImageId || !generatePreview) && (
            <>
              <FormInput
                label="Is preview transparent?"
                name={"__isTransparent"}
                type="checkbox"
              />
              <Upload
                name="shrPreviewImageId"
                fileCollection="Files_ArtPiecesPreview"
                maxFiles={1}
                initialFiles={[item?.shrPreviewImageId || ""]}
                fileType={["image/png", "image/jpeg"]}
                label="Upload Preview"
              />
            </>
          )}
        </>
      )}
    </div>
  )
}

export default ArtPieceUploads
